export const replaceLineBreak = (val: string) => {
    const splittedTextArray = val.split('\n');
    const newTextArray = splittedTextArray.filter((text) => !!text).map((text) => (text.indexOf('•') === 0 ? text : `•${text}`));

    return `${newTextArray.join('\n')}`;
};
